(()=>{
  'use strict';

  const $=(s,r=document)=>r.querySelector(s);
  const all=(s,r=document)=>[...r.querySelectorAll(s)];
  const esc=(v='')=>String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const icon={
    home:'<svg viewBox="0 0 24 24"><path d="M3 10.5 12 3l9 7.5M5.5 9.5V21h13V9.5M9.5 21v-6h5v6"/></svg>',
    search:'<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>',
    shop:'<svg viewBox="0 0 24 24"><path d="m3 18 5.2-8 3.2 4.4L15 8l6 10M7.3 18h10.8"/><circle cx="17.5" cy="5.2" r="1.5"/></svg>',
    heart:'<svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>',
    cart:'<svg viewBox="0 0 24 24"><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L20 8H6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>'
  };

  function active(k){
    const p=location.pathname;
    return k==='home'?p==='/':k==='shop'?/^\/(collections|products)/.test(p):k==='wishlist'?p.includes('/wishlist'):k==='cart'?p==='/cart':false;
  }

  function item(k,label,href,extra=''){
    const badge=(k==='cart'||k==='heart')?`<b class="yy-mobile-nav__badge yy-mobile-nav__badge--${k}" aria-hidden="true"></b>`:'';
    return `<a href="${esc(href)}" class="yy-mobile-nav__item ${extra} ${active(k)?'is-active':''}" data-yy="${k}" aria-label="${esc(label)}">${icon[k]}<span>${esc(label)}</span>${badge}</a>`;
  }

  function sheet(cls,title,body){
    const el=document.createElement('div');
    const panel=cls==='yy-search-sheet'?'yy-search-sheet__panel':'yy-cart-panel';
    const top=cls==='yy-search-sheet'?'yy-search-sheet__top':'yy-sheet-head';
    const closeClass=cls==='yy-search-sheet'?'yy-search-sheet__close':'yy-sheet-close';
    el.className=cls;
    el.setAttribute('aria-hidden','true');
    el.innerHTML=`<div class="${panel}" role="dialog" aria-modal="true" aria-label="${esc(title)}"><div class="${top}"><strong>${esc(title)}</strong><button type="button" class="${closeClass}" aria-label="Close ${esc(title)}">×</button></div>${body}</div>`;
    document.body.append(el);
    return el;
  }

  function open(el){
    el.classList.add('is-open');
    el.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
  }

  function close(el){
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden','true');
    if(!$('.yy-search-sheet.is-open')) document.documentElement.style.overflow='';
  }

  function money(cents){
    return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((Number(cents)||0)/100);
  }

  function wishlistUrl(){
    return $('.m-header__wishlist, .ssw-link-fave-menu')?.getAttribute('href')||'/pages/wishlist';
  }

  function wishlistCount(){
    try{
      const list=JSON.parse(localStorage.getItem('m-wishlist-products')||'[]');
      return Array.isArray(list)?new Set(list.filter(Boolean)).size:0;
    }catch{return 0;}
  }

  function init(){
    if($('.yy-mobile-nav')) return;

    const nav=document.createElement('nav');
    nav.className='yy-mobile-nav';
    nav.setAttribute('aria-label','Mobile navigation');
    nav.innerHTML=
      item('home','Home','/')+
      item('search','Search','#')+
      item('shop','Shop','/collections/all','yy-mobile-nav__shop')+
      item('heart','Wishlist',wishlistUrl())+
      item('cart','Cart','#');
    document.body.append(nav);

    const search=sheet('yy-search-sheet','Find your flow',`
      <form action="/search" method="get" class="yy-search-form" role="search">
        <div class="yy-search-input-wrap">
          <input name="q" type="search" placeholder="Search mats, recovery, meditation…" autocomplete="off" aria-label="Search products">
          <button type="button" class="yy-search-clear" aria-label="Clear search">×</button>
        </div>
        <button type="submit" class="yy-search-submit" aria-label="Search">${icon.search}</button>
      </form>
      <div class="yy-search-status" role="status" aria-live="polite"></div>
      <div class="yy-live-results" aria-live="polite"></div>
      <a class="yy-search-view-all" href="/search" hidden>View all results</a>
    `);

    const searchTrigger=$('[data-yy="search"]',nav);
    const cartTrigger=$('[data-yy="cart"]',nav);
    const searchInput=$('input[type="search"]',search);
    const searchResults=$('.yy-live-results',search);
    const searchStatus=$('.yy-search-status',search);
    const searchClear=$('.yy-search-clear',search);
    const searchViewAll=$('.yy-search-view-all',search);
    let searchTimer;
    let searchController;

    function setBadge(type,count){
      const b=$(`.yy-mobile-nav__badge--${type}`,nav);
      if(!b) return;
      b.textContent=count>99?'99+':count||'';
      b.classList.toggle('is-visible',count>0);
      b.setAttribute('aria-hidden',count>0?'false':'true');
    }

    function refreshWishlist(){
      const count=wishlistCount();
      setBadge('heart',count);
      const link=$('[data-yy="heart"]',nav);
      if(link) link.href=wishlistUrl();
    }

    function setSearchState(state,text=''){
      search.classList.toggle('is-loading',state==='loading');
      searchStatus.textContent=text;
    }

    function resetSearch(){
      searchInput.value='';
      searchResults.innerHTML='';
      searchViewAll.hidden=true;
      searchViewAll.removeAttribute('href');
      setSearchState('idle','');
      searchClear.classList.remove('is-visible');
      searchInput.focus();
    }

    function renderSearch(products,q){
      searchViewAll.href=`/search?q=${encodeURIComponent(q)}&type=product`;
      searchViewAll.textContent=`View all results for “${q}”`;
      searchViewAll.hidden=false;
      if(!products.length){
        searchResults.innerHTML='<div class="yy-live-empty"><strong>No matching products found.</strong><span>Try yoga mat, resistance band, foam roller or meditation.</span></div>';
        setSearchState('done','No matching products found.');
        return;
      }
      searchResults.innerHTML=products.map(p=>{
        const image=typeof p.image==='string'?p.image:(p.image?.url||'');
        return `<a class="yy-live-result" href="${esc(p.url||'#')}">${image?`<img src="${esc(image)}" alt="${esc(p.title||'Product')}" loading="lazy">`:''}<span><strong>${esc(p.title||'')}</strong><small>${esc(p.price||'')}</small></span><span aria-hidden="true">›</span></a>`;
      }).join('');
      setSearchState('done',`${products.length} product suggestions found.`);
    }

    async function searchProducts(q){
      searchController?.abort();
      searchController=new AbortController();
      setSearchState('loading','Searching…');
      try{
        const url=`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response=await fetch(url,{signal:searchController.signal,headers:{Accept:'application/json'}});
        if(!response.ok) throw new Error(`Search ${response.status}`);
        const data=await response.json();
        const products=data.resources?.results?.products||[];
        if(searchInput.value.trim()===q) renderSearch(products,q);
      }catch(err){
        if(err.name==='AbortError') return;
        searchResults.innerHTML='<div class="yy-live-empty">Search is temporarily unavailable. Use the search button to view all results.</div>';
        searchViewAll.href=`/search?q=${encodeURIComponent(q)}&type=product`;
        searchViewAll.hidden=false;
        setSearchState('error','Could not load suggestions.');
      }
    }

    searchTrigger.addEventListener('click',e=>{
      e.preventDefault();
      open(search);
      setTimeout(()=>searchInput.focus(),220);
    });
    const openPremiumCart=async()=>{
      await refreshCartBadge();
      const drawer=document.getElementById('MinimogCartDrawer');

      if(drawer&&typeof drawer.open==='function'){
        drawer.open(cartTrigger);
        return;
      }

      const headerCart=document.querySelector('.m-cart-icon-bubble');
      if(headerCart){
        headerCart.click();
        return;
      }

      location.href='/cart';
    };

    cartTrigger.addEventListener('click',e=>{
      e.preventDefault();
      openPremiumCart();
    });

    $('.yy-search-sheet__close',search).addEventListener('click',()=>close(search));
    search.addEventListener('click',e=>{if(e.target===search) close(search);});
    document.addEventListener('keydown',e=>{if(e.key==='Escape') close(search);});

    all('.yy-mobile-nav__item',nav).forEach(a=>a.addEventListener('pointerdown',()=>{
      a.classList.add('yy-tap');
      setTimeout(()=>a.classList.remove('yy-tap'),280);
    }));

    searchInput.addEventListener('input',()=>{
      clearTimeout(searchTimer);
      const q=searchInput.value.trim();
      searchClear.classList.toggle('is-visible',q.length>0);
      if(q.length<2){
        searchController?.abort();
        searchResults.innerHTML='';
        searchViewAll.hidden=true;
        setSearchState('idle',q.length===1?'Type one more character to search.':'');
        return;
      }
      searchTimer=setTimeout(()=>searchProducts(q),220);
    });
    searchClear.addEventListener('click',resetSearch);

    async function refreshCartBadge(){
      try{
        const c=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>{
          if(!r.ok) throw new Error(`Cart ${r.status}`);
          return r.json();
        });
        setBadge('cart',c.item_count||0);
        return c;
      }catch{
        return null;
      }
    }

    refreshCartBadge();
    refreshWishlist();

    const yyCartDrawer=document.getElementById('MinimogCartDrawer');
    if(yyCartDrawer&&'MutationObserver' in window){
      const yyCartDrawerObserver=new MutationObserver(()=>{
        if(!yyCartDrawer.classList.contains('m-cart-drawer--active')){
          nav.classList.remove('is-hidden');
        }
      });
      yyCartDrawerObserver.observe(yyCartDrawer,{attributes:true,attributeFilter:['class']});
    }
    document.addEventListener('cart:updated',()=>refreshCartBadge());
    document.addEventListener('cart:refresh',()=>setTimeout(refreshCartBadge,450));
    document.addEventListener('submit',e=>{if(e.target.matches('form[action*="/cart/add"]')) setTimeout(()=>refreshCartBadge(),700);});
    document.addEventListener('click',e=>{
      if(e.target.closest('.m-wishlist-button,.m-wishlist-remove-button')) setTimeout(refreshWishlist,30);
    });
    window.addEventListener('storage',e=>{if(e.key==='m-wishlist-products') refreshWishlist();});

    let y=scrollY,ticking=false;
    addEventListener('scroll',()=>{
      if(ticking) return;
      ticking=true;
      requestAnimationFrame(()=>{
        const current=scrollY;
        if(current<160){
          nav.classList.remove('is-hidden');
        }else if(current>y+12&&current>180){
          nav.classList.add('is-hidden');
        }else if(current<y-8){
          nav.classList.remove('is-hidden');
        }
        y=current;
        ticking=false;
      });
    },{passive:true});
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
